/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2020/05/google-maps-in-data-studio/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2020/05/google-maps-in-data-studio/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2020/05/google-maps-in-data-studio/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Guide to Google Maps in Data Studio (May 2020) - How to Use Google Maps in Data Studio? - Tribalism",
  date: "2020-05-04",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. This blog is a guide on how to use Google Maps in Data Studio.",
  image: "/img/posts/2020-05-04-GoogleMaps-in-data-studio/newgooglemaps16.webp",
  url: "https://www.tribalism.com.au/blog-post/2020/05/google-maps-in-data-studio",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="How to Use Google Maps in Data Studio? - Tribalism"
        image="/img/posts/2021-06-30-linkedin/blog-image-one.webp"
        url="https://www.tribalism.com.au/blog-post/2020/05/google-maps-in-data-studio"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. This blog is a guide on how to use Google Maps in Data Studio."

        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2020-05-04-GoogleMaps-in-data-studio/newgooglemaps16.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Guide to google maps in data studio (may 2020)
              </h1>
              <h4 className={classes.subtitle}>
              Google maps in data studio - finally!
              </h4>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>
      <SectionSimilarStories />
      <Footer
        
      />
    </div>
  );
}
